export const isFileSizeAllowed = ({ file, size }) => {
  if (file.size > size * 1024 * 1024) {
    return false;
  } else {
    return true;
  }
};
